const passwordShow = () => {
    const eye = document.querySelectorAll('.eye');
    if(eye) {
        eye.forEach(i => {
            i.addEventListener('mousedown', (e) => {
                e.preventDefault()
                i.previousElementSibling.type = 'text';
            })
            i.addEventListener('mouseup', (e) => {
                e.preventDefault()
                i.previousElementSibling.type = 'password';
            })
            i.addEventListener('touchstart', (e) => {
                e.preventDefault()  
    
                i.previousElementSibling.type = 'text';
            })
            i.addEventListener('touchend', (e) => {
                e.preventDefault()
    
                i.previousElementSibling.type = 'password';
            })
            i.addEventListener('mouseleave', (e) => {
                e.preventDefault()
    
                i.previousElementSibling.type = 'password';
    
            })
        })
    }
    
}

export default passwordShow;